import unescapedText from 'I18n/utils/unescapedText';
import Markdown from 'ai-rendering-library/components/text/Markdown';
import styled from 'foundations-theming-specialty/utils';
import BrandVoiceInfo from '../components/BrandVoiceInfo';
import { copilotV2ExtractTitleAndContentFromSections, extractBrandVoiceInformationFromMessage, extractTitleAndContentFromSections } from '../utils/pluginUtils';
// Remove this once the once chatspot-ui changes are deployed everywhere.

import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContentTextContainer = styled.div.withConfig({
  displayName: "EditorPlugin__ContentTextContainer",
  componentId: "t336un-0"
})(["background-color:", ";border-radius:", ";white-space:pre-wrap;padding:", ";margin-right:", ";margin-bottom:", ";"], ({
  theme
}) => theme.color['breeze-fill-secondary-hover'], ({
  theme
}) => theme.borderRadius[200], ({
  theme
}) => theme.space[300], ({
  theme
}) => theme.space[200], ({
  theme
}) => theme.space[200]);
export const MESSAGE_NOT_FOUND = 'MESSAGE_NOT_FOUND';

/**
 * @deprecated - can delete along with Copilot:V2 gate / isUngatedForCopilotV2
 *
 * V2 response omits this entire object and includes within sections field instead
 */

const ReplaceOrInsertButton = ({
  actionFn,
  hasSelection,
  textToInsert,
  ChatSpotStyledButtonComponent,
  message,
  appName,
  sessionId,
  usageTracker
}) => {
  const messageId = message.id;
  const {
    brandVoiceOptions,
    intent
  } = message.query;
  const {
    isSetUp,
    isEnabledForApp
  } = brandVoiceOptions || {};
  const usingBrandVoice = Boolean(isSetUp && isEnabledForApp);
  const buttonText = hasSelection ? unescapedText('copilotPlugins.editorPlugin.replace') : unescapedText('copilotPlugins.editorPlugin.insert');
  const handleInsert = () => {
    return actionFn({
      actionType: 'insert',
      html: textToInsert,
      userThread: buttonText
    });
  };
  return /*#__PURE__*/_jsx(ChatSpotStyledButtonComponent, {
    "data-test-id": "copilot-replace-or-insert-button",
    onClick: handleInsert,
    usageTracker: usageTracker,
    usageTrackerAppLocationKey: "copilot-plugins",
    eventName: "collaborationModeInteractions",
    eventProperties: {
      action: hasSelection ? 'replace-text-button-clicked' : 'insert-text-button-clicked',
      interactionType: 'copilot-sidebar-interaction',
      messageId,
      featureCategoryId: intent,
      textUsed: textToInsert,
      sessionId,
      inApp: appName,
      usingBrandVoice
    },
    children: buttonText
  });
};
export const EditorPlugin = {
  gate: 'Copilot:Collaborate',
  intentTypes: ['content_rewrite', 'text_generate'],
  collaborateCopilotMessageTypes: ['INSERT'],
  sectionRenderer: (message, __MarkdownComponent, isUngatedForCopilotV2) => {
    const {
      titleText,
      contentText
    } = isUngatedForCopilotV2 ? copilotV2ExtractTitleAndContentFromSections(message) : extractTitleAndContentFromSections(message);
    const {
      brandVoiceChannel
    } = extractBrandVoiceInformationFromMessage(message);

    /**
     * @deprecated - can delete along with Copilot:V2 gate / isUngatedForCopilotV2
     */
    const {
      brandVoiceOptions
    } = (message === null || message === void 0 ? void 0 : message.query) || {};
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [typeof titleText === 'string' ? /*#__PURE__*/_jsx(Markdown, {
        html: titleText
      }) : /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        children: titleText
      }), contentText && /*#__PURE__*/_jsxs(ContentTextContainer, {
        "data-test-id": "copilot-markdown-response",
        children: [/*#__PURE__*/_jsx(Markdown, {
          html: contentText
        }), /*#__PURE__*/_jsx(BrandVoiceInfo, {
          isUngatedForCopilotV2: isUngatedForCopilotV2,
          brandVoiceOptions: brandVoiceOptions,
          brandVoiceChannel: brandVoiceChannel
        })]
      })]
    });
  },
  actionsRenderer: ({
    state,
    message,
    actionFn,
    ChatSpotButtons,
    ChatSpotStyledButtonComponent,
    appName,
    sessionId,
    usageTracker,
    isUngatedForCopilotV2
  }) => {
    const {
      contentText
    } = isUngatedForCopilotV2 ? copilotV2ExtractTitleAndContentFromSections(message) : extractTitleAndContentFromSections(message);
    const isPluginActive = state && 'hasFocus' in state && 'hasSelection' in state && state.hasFocus;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [isPluginActive && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(ReplaceOrInsertButton, {
          actionFn: actionFn,
          textToInsert: contentText,
          hasSelection: state.hasSelection,
          ChatSpotStyledButtonComponent: ChatSpotStyledButtonComponent,
          message: message,
          appName: appName,
          sessionId: sessionId,
          usageTracker: usageTracker
        })
      }), /*#__PURE__*/_jsx(ChatSpotButtons, {
        text: contentText,
        contentToCopy: contentText
      })]
    });
  }
};